// extracted by mini-css-extract-plugin
export default {"contact-form":"contact-form__2IGI-"};